import { getRgObjectsOfType as n, RG_TYPE as p, isPolygonClosed as a, sum as f } from "@project-rouge/rg-core";
import { getPolygonPerimeter as g } from "../../geometry-utils/core/index16.js";
const m = (t, r) => {
  var i, l, s;
  if (r && (t = r.flatMap((e) => n(t, e))), "uuid" in t) {
    let e;
    return t.type === p.Zone ? e = (i = t.data) == null ? void 0 : i.realPoly.slice() : e = (s = (l = t.data) == null ? void 0 : l.polygon) == null ? void 0 : s.slice(), e ? (a(e) || e.push(e[0]), g(e)) : t.size[0] * 2 + t.size[2] * 2;
  }
  return t.map((e) => m(e)).reduce(f, 0);
};
export {
  m as getPerimeter
};
//# sourceMappingURL=index8.js.map
